export default __webpack_public_path__ + "static/media/ifeel-benefit.58eda63d.png";